module.exports = __webpack_public_path__ + "img/au.9f94720a.svg";